import getConfig from "next/config";

import serviceRequest from "api/serviceRequest";

export type ReservationsApiErrors = { title: string; detail: string }[];

export type ReservationsApiErrorsResponse = {
  errors: ReservationsApiErrors;
};

const { publicRuntimeConfig } = getConfig();

// Initialize the service request with the app and environment
const reservationApi = serviceRequest();

// Configure and set upstream URL
// The baseUrl can be set depending on the `domainCountryCode`. C3PI-676 updated
// the calls to `retrieveCart` and `retrieveCartServerSide` to make use of the
// CA URL, but did not make any changes here as that would impact all res-api
// calls and may have a broader impact than only the cart retrieval. If the CA
// URL is needed on all calls, then this and `resApiClient` need to be updated
// to accept a `domainCountryCode` parameter to determine which URL to use.
reservationApi.defaults.baseURL =
  publicRuntimeConfig.services.reservationsApi.url;
reservationApi.defaults.withCredentials = true;

export default reservationApi;
